import React, { useEffect, useState } from 'react'
import { HeaderPage } from '../../components/Admin'
import { AddEditFormSetting, StoreSettings } from '../../components/Admin/Settings';
import { ModalBasic } from '../../components/common';
import { useSettings } from '../../hook/useSettings';



export  function SettingsAdmin() {
  
    const {loading, getSettings, setting,  editSetting, deleteSetting} = useSettings();
    

   
    const [showModal, setShowModal] = useState(false);
    const [titleModal, setTitleModal] = useState(null);
    const [contentModal, setContentModal] = useState(null);
    const [refresh, setRefresh] = useState(null); 

    const openCloseModal = () => { setShowModal(prev =>!prev)}
    const onRefresh = () => {setRefresh(prev =>!prev)}

    //const {loading, category, getCategories, deleteCategory} = useCategories();
    
    const newSettingAdmin = () => {
        setTitleModal('Nuevo Setting');
        setContentModal(
            <AddEditFormSetting onClose={openCloseModal} onRefresh={onRefresh} />
        )
        openCloseModal();
    }


    const editSettingAdmin = (data) =>{
        setTitleModal('Editar Setting');
        setContentModal(
            <AddEditFormSetting onClose={openCloseModal} onRefresh={onRefresh} setting={data} />
        )
        openCloseModal();
    }

    const onDeleteSetting = async (data) => {
        try {        
        const alert = window.confirm('Are you sure you want to delete');
        if(alert){
            await deleteSetting(data.id);
            setRefresh(prev =>!prev);
        }
       
        } catch (error) {
            console.log(error);
        }
        
    }


    
    useEffect(() => {
        getSettings();
  
      }, [refresh])
    
  return (
    <>
    <HeaderPage title="Settings" btnClick={newSettingAdmin} />



    {loading ? (
        <p>Cargando...</p>
      ):(
        <StoreSettings dataSettings={setting} />          
        
        
      )}

    <ModalBasic
        show={showModal}
        onClose={openCloseModal}
        title={titleModal}
        children={contentModal}
      />

    </>
  )
}
